import React, { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import { PageContext } from '../../cnr/contexts/PageContext';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';

export const PushToProduction = () => {

  // pageContext
  const pageContext = useContext(PageContext);
  const { page_state } = pageContext ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { settingsOptions } = aps_global ?? {}
  const { useDarkMode } = settingsOptions ?? {}

  const handleClick = () => { }

  const form = () => <Segment basic inverted={useDarkMode}>
    Create this client in production
    {/* <Form>
      <Form.Button onClick={() => { handleClick() }}>Push To Production</Form.Button>
    </Form> */}
  </Segment>

  const footer = () => <UiSaveButtons save={{ oc: handleClick, caption: 'Push Data to Production?' }} />

  const wrapper = () => <Wrapper
    content={form()}
    footer={footer()}
    wrapperType={wrapperTypes.paddedFooter}
    updatingCaption={'Push to Production?'}
  />

  return wrapper()

}